import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import LeaderboardModel from "@/game-lol/models/lol-doombots-leaderboard.mjs";

export default function ({
  region,
  options = {},
}: {
  region: string;
  options?: object;
}): Promise<void> {
  return getData(
    `${appURLs.LOL}/lol/leaderboard/doom_bots_2025/${region === "world" ? "global" : region.toLowerCase()}`,
    LeaderboardModel,
    ["lol", `doombotsLeaderboard-${region}`],
    {
      ...options,
      shouldSkipDBRead: true,
    },
  ).catch((_) => {});
}
